import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { scItems, scLinks } from './SecurityItems'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Index } from '@/components/enlayouts/Legal/Index'
import { SectionTitle } from '@/components/enlayouts/Legal/SectionTitle'

const sectionTitle = {
  children: <h2>Information Security Policy</h2>,
}

const tSummary = (
  <p>
    TRIAL Group (representing TRIAL Holdings, Inc. and its group companies) formulated the Information Security Policy in order to gain the trust of our customers and society at large at all times by establishing a strict management system against information leak risks.
    <br />
    TRIAL Group shall comply with the Information Security Policy and strive to maintain information security by protecting information assets from various threats and by handling them appropriately.
  </p>
)

export const SecurityPage = () => {
  return (
    <>
      <Head
        title="Information Security Policy"
        description="The information security policy for TRIAL Holdings, Inc. "
        ogp={{ type: 'article', url: 'en/legal/security-policy/' }}
      />
      <SecurityContainer>
        <SectionTitle {...sectionTitle} />
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 70, sp: 35 }} />
        <Index columnGap={70} listType="article" links={scLinks} />
        <Spacer h={{ pc: 70, sp: 40 }} />
        {scItems.map(({ children, id }, index) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < scItems.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </SecurityContainer>
    </>
  )
}
SecurityPage.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Legal', path: '/en/legal/' },
    { name: 'Information Security Policy', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const SecurityContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`
